module.exports = "/images/sacoa.svg?b79600cf904fdf25333012400b8baa08";